import { z } from 'zod';
import { OrgInviteStatusSchema, OrgRoleSchema } from '../enums.js';
import { EmailSchema, IdSchema, IsoDateTimeSchema } from './common.js';
/** orgs/{orgId} */
export const OrgSchema = z.object({
    id: IdSchema,
    name: z.string().min(1).max(200),
    slug: z
        .string()
        .min(1)
        .max(80)
        .regex(/^[a-z0-9]+(-[a-z0-9]+)*$/, 'Expected a lowercase, hyphenated slug'),
    ownerUid: IdSchema,
    createdAt: IsoDateTimeSchema,
    createdByUid: IdSchema,
});
/** orgs/{orgId}/members/{uid} */
export const OrgMemberSchema = z.object({
    uid: IdSchema,
    role: OrgRoleSchema,
    addedByUid: IdSchema,
    addedAt: IsoDateTimeSchema,
});
/** orgs/{orgId}/settings/devPreferences — pre-fills the TDD questionnaire. One flat doc covering
 * every DEV_PREFERENCE_FIELDS entry regardless of project type — an org runs projects of several
 * types at once, so the fields aren't split up per type here; each field's relevant project
 * type(s) are tagged in DEV_PREFERENCE_FIELD_META (enums.ts) instead, which is what the "Dev
 * preferences" settings page's search filters on. */
export const DevPreferencesSchema = z.object({
    frontend: z.string().max(300).optional(),
    styling: z.string().max(300).optional(),
    backend: z.string().max(300).optional(),
    architectureStyle: z.string().max(300).optional(),
    datastore: z.string().max(300).optional(),
    auth: z.string().max(300).optional(),
    hosting: z.string().max(300).optional(),
    cicd: z.string().max(300).optional(),
    testing: z.string().max(300).optional(),
    observability: z.string().max(300).optional(),
    thirdPartyServices: z.string().max(300).optional(),
    sourceEnvironment: z.string().max(300).optional(),
    targetCloudProvider: z.string().max(300).optional(),
    complianceTargets: z.string().max(300).optional(),
    attackSurface: z.string().max(300).optional(),
    conventions: z.string().max(2000).optional(),
    updatedAt: IsoDateTimeSchema.optional(),
    updatedByUid: IdSchema.optional(),
});
export const CreateOrgInputSchema = z.object({
    name: z.string().min(1).max(200),
});
export const AddOrgMemberInputSchema = z.object({
    email: z.string().email(),
    role: OrgRoleSchema,
});
export const ChangeOrgMemberRoleInputSchema = z.object({ role: OrgRoleSchema });
/** orgs/{orgId}/invites/{inviteId} — a pending, email-addressed invite. Accepted automatically
 * the next time the invited email signs in (see POST /auth/session), regardless of whether that
 * email's domain is on the global allowlist. */
export const OrgInviteSchema = z.object({
    id: IdSchema,
    orgId: IdSchema,
    email: EmailSchema,
    role: OrgRoleSchema,
    status: OrgInviteStatusSchema,
    createdByUid: IdSchema,
    createdAt: IsoDateTimeSchema,
    acceptedAt: IsoDateTimeSchema.optional(),
    acceptedByUid: IdSchema.optional(),
    revokedAt: IsoDateTimeSchema.optional(),
    revokedByUid: IdSchema.optional(),
});
//# sourceMappingURL=org.js.map